export default __webpack_public_path__ + "static/media/Trash_Light.17490de0.svg";